import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

import ArchiveDateStore from '../../../store/ArchiveDateStore';
import styles from '../css/Archives.module.css';
import ArchiveStore from '../../../store/ArchiveStore';
import AnchorStore from '../../../store/AnchorStore';

import AnchorFilters from './AnchorFilters';
import SegmentFilters from './SegmentFilters';


const CURRENT_YEAR = new Date().getFullYear();

@observer
class ArchivesFilters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsing: {
        segment: false,
        anchor: false,
        vintage: false,
        date: false,
      },
      currentYear: CURRENT_YEAR,
      fullTextSearch: '',
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.setYearFilterFromUrl();
    ArchiveStore.setSelectedFilter('');
    ArchiveDateStore.setStartYear();
    AnchorStore.setAnchors();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleHrefDateClick = (type, year, month, e) => {
    const { setTypeOfListingForDate } = this.props;

    e.preventDefault();
    this.handleClick(type);
    setTypeOfListingForDate(type, year, month);
  };

  handleClickOutside = (event) => {
    const { collapsing } = this.state;
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      ArchiveStore.setSelectedFilter('');
      this.setState({
        collapsing: {
          ...collapsing,
          segment: false,
          anchor: false,
          date: false,
          vintage: false,
          fullSearch: false,
        },
      });
    }
  };

  handleHrefClick = (id, type, title, e) => {
    const { setTypeOfListing } = this.props;
    e.preventDefault();
    this.handleClick(type);
    setTypeOfListing(type, id, title);
  };

  onClick = (event) => {
    const type = event.target.dataset.listing;
    const { collapsing } = this.state;
    ArchiveStore.setSelectedFilter(type);
    switch (type) {
      case 'segment':
        this.setState({
          collapsing: {
            ...collapsing,
            segment: !collapsing.segment,
            anchor: false,
            date: false,
            vintage: false,
            fullSearch: false,
          },
        });
        break;
      case 'anchor':
        this.setState({
          collapsing: {
            ...collapsing,
            anchor: !collapsing.anchor,
            segment: false,
            date: false,
            vintage: false,
            fullSearch: false,
          },
        });
        break;
      case 'vintage':
        this.setState({
          collapsing: {
            ...collapsing,
            vintage: !collapsing.vintage,
            anchor: false,
            segment: false,
            date: false,
            fullSearch: false,
          },
        });
        break;
      case 'fullSearch':
        this.setState({
          collapsing: {
            ...collapsing,
            fullSearch: !collapsing.fullSearch,
            anchor: false,
            segment: false,
            date: false,
            vintage: false,
          },
        });
        break;
      case 'date':
        this.setState({
          collapsing: {
            ...collapsing,
            date: !collapsing.date,
            vintage: false,
            anchor: false,
            segment: false,
            fullSearch: false,
          },
        });
        break;
    }
  };

  setYearFilterFromUrl = () => {
    const { slug } = this.props;
    if (/(\d\d\d\d\/\d\d)/.test(slug)) {
      const [slugYear, slugMonth] = slug.split('/');

      ArchiveDateStore.setSelectedMonth(slugMonth);
      ArchiveDateStore.setSelectedYear(slugYear);
    }
  };

  renderFullSearchFilters = () => {
    const { fullTextSearch, collapsing } = this.state;

    return (
      <div
        className={`filter-list ${collapsing.fullSearch ? '' : 'collapse'}`}
        id="filter-dates"
      >
        <div className="row-r date-selection-wrapper">
          <div className="date-selection">
            <input
              placeholder="Type your word here"
              type="text"
              value={fullTextSearch}
              onChange={this.onFullSearchChange}
              onKeyDown={this.onKeyDown}
            />
            <button
              id="view_archives_button"
              onClick={this.redirectToArchiveSearch}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    );
  };

  onKeyDown = (e) => {
    if (e.keyCode === 13) {
      this.redirectToArchiveSearch(e);
    }
  };

  onFullSearchChange = (e) => {
    this.setState({ fullTextSearch: e.target.value });
  };

  changeArchiveYear = (e) => {
    const { archiveSelectedMonth, currentYear } = this.state;
    const isCurrentYear = currentYear === e.target.value;
    const hasSelectedMonth = ArchiveDateStore.monthsInCurrentYearFromLatest.find(
      (month) => month.name === archiveSelectedMonth
    );
    const stateParams = { archiveSelectedYear: e.target.value };

    if (isCurrentYear && !hasSelectedMonth) {
      stateParams.archiveSelectedMonth =
        ArchiveDateStore.monthsInCurrentYearFromLatest[0].number;
    } else if (e.target.value === 2011) {
      stateParams.archiveSelectedMonth = 12;
    }

    ArchiveDateStore.setSelectedYear(stateParams.archiveSelectedYear);
  };

  changeArchiveMonth = (e) => {
    ArchiveDateStore.setSelectedMonth(e.target.value);
  };

  redirectToArchiveDate = (e) => {
    const { selectedMonth, selectedYear } = ArchiveDateStore;

    return `/${selectedYear}/${selectedMonth}`;
  };

  redirectToArchiveSearch = (e) => {
    e.preventDefault();
    window.location.href = `/archives?search=${encodeURIComponent(
      this.state.fullTextSearch
    )}`;
  };

  renderDateFilters = () => {
    const { collapsing, currentYear } = this.state;
    const {
      months,
      selectedMonth,
      selectedYear,
      yearsFromLatest,
      monthsInCurrentYearFromLatest,
    } = ArchiveDateStore;

    return (
      <div
        className={classnames('filter-list',
          { 'collapse': !collapsing?.date })}
        id="filter-dates"
      >
        <div className="row-r date-selection-wrapper">
          <div className="date-selection">
            <select
              className="custom-select"
              id="select-year"
              value={selectedYear}
              onChange={this.changeArchiveYear}
            >
              {yearsFromLatest.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            <select
              className="custom-select"
              id="select-month"
              value={selectedMonth}
              onChange={this.changeArchiveMonth}
            >
              {currentYear === selectedYear ? (
                monthsInCurrentYearFromLatest.map((month) => (
                  <option key={month.name} value={month.number}>
                    {month.name}
                  </option>
                ))
              ) : selectedYear == 2011 ? (
                <option value={12}>{'December'}</option>
              ) : (
                months.map((month) => (
                  <option key={month.name} value={month.number}>
                    {month.name}
                  </option>
                ))
              )}
            </select>
            <Link id="view_archives_button" to={this.redirectToArchiveDate()}>
              VIEW
            </Link>
          </div>
        </div>
      </div>
    );
  };

  clearFilter = () => {
    this.setState({
      collapsing: {
        segment: false,
        anchor: false,
        vintage: false,
        date: false,
      },
    });
  };

  render() {
    const { user } = this.props;
    const { collapsing } = this.state;
    const {
      selectedFilter,
      segmentsList,
      searchFilterString,
    } = ArchiveStore;
    const showSearch = user?.features?.includes('SEGMENT_SEARCH');

    return (
      <div
        ref={this.setWrapperRef}
        className={styles.searchableFilters}
        id="subnav"
      >
        <div className={styles.filterContainer}>
          <ul className={styles.navTabs}>
            <li className={styles.navList}>
              <button
                className={classnames(styles.buttonBlank, { [styles.buttonActive]: collapsing.anchor })}
                data-listing="anchor"
                type="button"
                onClick={this.onClick}
              >
                Anchors
              </button>
              {collapsing?.anchor && (
                <div
                  className={classnames(
                    styles.contentLight,
                    styles.anchorContent
                  )}
                >
                  <AnchorFilters
                    clearFilter={this.clearFilter}
                    collapsing={collapsing}
                  />
                </div>
              )}
            </li>
            <li className={styles.navList}>
              <button
                className={classnames(styles.buttonBlank, { [styles.buttonActive]: collapsing.segment })}
                data-listing="segment"
                type="button"
                onClick={this.onClick}
              >
                Segments
              </button>
            </li>
            <li className={styles.navList}>
              <button
                className={classnames(styles.buttonBlank, { [styles.buttonActive]: collapsing.date })}
                data-listing="date"
                type="button"
                onClick={this.onClick}
              >
                Date
              </button>
            </li>
            {showSearch && (
              <li className={styles.navList}>
                <button
                  className={classnames(styles.buttonBlank, { [styles.buttonActive]: collapsing.fullSearch })}
                  data-listing="fullSearch"
                  type="button"
                  onClick={this.onClick}
                >
                  Search
                </button>
                <div className={styles.contentLight}>
                  {showSearch && this.renderFullSearchFilters()}
                </div>
              </li>
            )}
            {showSearch && (
              <li className={styles.searchContainer}>
                <input
                  className={styles.searchInput}
                  placeholder="Search"
                  type="text"
                  value={searchFilterString}
                  onChange={ArchiveStore.handleSearchInputChange}
                />
              </li>
            )}
          </ul>
          {collapsing?.segment && segmentsList?.length > 0 && (
            <div className={styles.contentLight}>
              <SegmentFilters
                clearFilter={this.clearFilter}
                collapsing={collapsing.segment}
                segments={segmentsList}
              />
            </div>
          )}
          {selectedFilter === 'date' && (
            <div className={`${styles.contentLight} ${styles.dateFilter}`}>
              {this.renderDateFilters()}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ArchivesFilters;
